export const steps = [
  { id: 'businessType', title: 'What type of business are you?' },
  { id: 'industry', title: 'What industry are you in?' },
  { id: 'goals', title: 'What are your main business goals?' },
  { id: 'budget', title: "What's your monthly budget for tools?" },
  { id: 'features', title: 'Which features are most important?' },
  { id: 'teamSize', title: 'How big is your team?' },
  { id: 'businessStage', title: 'What stage is your business in?' },
  { id: 'technicalExpertise', title: "What's your technical expertise?" }
] as const;

export type StepId = typeof steps[number]['id'];